export const canceledStyleUtils = (canceled: boolean) =>
	canceled
		? {
				textDecoration: 'line-through',
				opacity: 0.5,
		  }
		: {};
